import { getApiUrl, getPublicApiUrl, tokenManager } from '../config';

// Create a history object to use for navigation
// This will be initialized in App.js
let navigate;
export const setNavigate = (nav) => {
  navigate = nav;
};

let onUnauthorizedCallback = () => {};
export const setOnUnauthorizedCallback = (callback) => {
  onUnauthorizedCallback = callback;
};

const handleUnauthorized = () => {
  tokenManager.removeToken();
  onUnauthorizedCallback();
  if (navigate) {
    navigate('/login');
  } else {
    // Fallback if navigate is not set
    window.location.href = `${process.env.PUBLIC_URL || ''}/login`;
  }
};

export const fetchApiWithProgress = (endpoint, options = {}, apiUrlBuilder = getApiUrl) => {
  return new Promise((resolve, reject) => {
    const { body, onUploadProgress, ...customOptions } = options;

    const xhr = new XMLHttpRequest();
    const url = apiUrlBuilder(endpoint);

    xhr.open(customOptions.method || 'POST', url, true);

    const headers = {
      ...tokenManager.getAuthHeader(),
    };

    for (const key in headers) {
      if (headers.hasOwnProperty(key)) {
        xhr.setRequestHeader(key, headers[key]);
      }
    }

    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable && onUploadProgress) {
        const percentCompleted = Math.round((event.loaded * 100) / event.total);
        onUploadProgress(percentCompleted);
      }
    };

    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        if (xhr.status === 204) {
          resolve(null);
        } else {
          resolve(JSON.parse(xhr.responseText));
        }
      } else if (xhr.status === 401) {
        handleUnauthorized();
        reject(new Error('Unauthorized'));
      } else {
        let errorData = null;
        try {
          errorData = JSON.parse(xhr.responseText);
        } catch (e) {
          errorData = { message: xhr.statusText };
        }
        if (xhr.status === 403 && errorData?.message === 'Invalid or expired token') {
          handleUnauthorized();
          reject(new Error('Unauthorized'));
        } else {
        reject(new Error(errorData?.error || errorData?.message || `HTTP error! status: ${xhr.status}`));
        }
      }
    };

    xhr.onerror = () => {
      console.error(`API call to ${endpoint} failed:`, xhr.statusText);
      reject(new Error('Network request failed'));
    };

    if (body) {
      xhr.send(body);
    } else {
      xhr.send();
    }
  });
};

export const fetchApi = async (endpoint, options = {}, apiUrlBuilder = getApiUrl) => {
  const { body, ...customOptions } = options;

  const headers = {
    ...tokenManager.getAuthHeader(),
  };

  if (!(body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }

  const config = {
    ...customOptions,
    headers,
  };

  if (body) {
    if (body instanceof FormData) {
      config.body = body;
    } else {
      config.body = JSON.stringify(body);
    }
  }

  try {
    const response = await fetch(apiUrlBuilder(endpoint), config);

    if (response.ok) {
      // Handle successful responses
      if (response.status === 204) {
        return null; // No content
      }
      return await response.json();
    }

    // Handle errors
    if (response.status === 401) {
      handleUnauthorized();
      throw new Error('Unauthorized');
    }

    let errorData = null;
    try {
      errorData = await response.json();
    } catch (e) {
      errorData = { message: response.statusText };
    }

    if (response.status === 403 && errorData?.message === 'Invalid or expired token') {
      handleUnauthorized();
      throw new Error('Unauthorized');
    }

    throw new Error(errorData?.error || errorData?.message || `HTTP error! status: ${response.status}`);
    
  } catch (error) {
    console.error(`API call to ${endpoint} failed:`, error);
    throw error;
  }
};
